module.exports = __webpack_public_path__ + "img/en.15d98beb.png";